export default "__VITE_ASSET__BaTGMYcG__"